import contractTypesForEmployee from "../../data/employee/contractTypesForEmployee";
import contractTypesForSite from "../../data/employee/contractTypesForSite";
import dayOfRestTypes from "../../data/employee/dayOfRestTypes";
import employeeShiftTypes from "../../data/employee/employeeShiftTypes";
import genderTypes from "../../data/employee/genderTypes";
import marriageStatusTypes from "../../data/employee/marriageStatusTypes";
import paymentTypes from "../../data/employee/paymentTypes";
import parseDropDownValue from "../utils/parseDropDownValue";

export default function preprocessDataForExport(items, options = {}) {
  items = JSON.parse(JSON.stringify(items));
  let newItems = [...items];

  const employeeFunctionsFromWindow =
    typeof window !== "undefined" ? window.employeeFunctions : null;

  const employeeFunctions =
    (options.employeeFunctions &&
    Array.isArray(options.employeeFunctions) &&
    options.employeeFunctions.length
      ? options.employeeFunctions
      : null) ||
    (Array.isArray(employeeFunctionsFromWindow) && employeeFunctionsFromWindow.length
      ? employeeFunctionsFromWindow
      : null) ||
    contractTypesForSite;

  for (let newItem of newItems) {
    if (newItem["Employee Responsibility"]) {
      newItem["Employee Responsibility"] = parseDropDownValue({
        query: newItem["Employee Responsibility"],
        theArray: employeeFunctions,
      });
    }

    if (newItem["Day Of Rest"]) {
      newItem["Day Of Rest"] = parseDropDownValue({
        query: newItem["Day Of Rest"],
        theArray: dayOfRestTypes,
      });
    }

    if (newItem["Shift"]) {
      const parsedShift = parseDropDownValue({
        query: newItem["Shift"],
        theArray: employeeShiftTypes,
      });
      newItem["Shift"] = parsedShift === "Non" ? newItem["Shift"] : parsedShift;
    }

    if (newItem["Gender"]) {
      newItem["Gender"] = parseDropDownValue({
        query: newItem["Gender"],
        theArray: genderTypes,
      });
    }

    if (newItem["Marriage Status"]) {
      newItem["Marriage Status"] = parseDropDownValue({
        query: newItem["Marriage Status"],
        theArray: marriageStatusTypes,
      });
    }

    if (newItem["Payment Type"]) {
      newItem["Payment Type"] = parseDropDownValue({
        query: newItem["Payment Type"],
        theArray: paymentTypes,
      });
    }

    if (newItem["Contract Type"]) {
      newItem["Contract Type"] = parseDropDownValue({
        query: newItem["Contract Type"],
        theArray: contractTypesForEmployee,
      });
    }

    //Contract Type

    // console.log(newItem);

    //make all the string capital

    for (let key in newItem) {
      let theValue =
        typeof newItem[key] == "string"
          ? newItem[key].toUpperCase()
          : parseNonStringFields(newItem[key]);

      if (key.toLowerCase().indexOf("date") !== -1) {
        theValue = parseDateForExport(theValue, key);
      }
      newItem[key] = theValue;
    }
  }

  function parseDateForExport(dateString, keyForDebugging) {
    if (!dateString) return "";
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      console.log("Invalid date ", dateString, keyForDebugging);
      return dateString;
      // throw new Error("Invalid date string");
    }

    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // months are 0-based
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  }

  function parseNonStringFields(val) {
    if (typeof val == "boolean") {
      if (val == true) {
        return "Oui";
      } else {
        return "Non";
      }
    } else {
      return val;
    }
  }

  return newItems;
}
